// Path: ./src/hooks/useFlyerItemCategories.ts
import React, { useEffect, useCallback } from "react";
import { adminApiService } from "../utils/api";
import { GfFlyerItemCategory } from "@swagger/typescript-fetch-goflyer";
import { GoFlyerAdminContext } from "../contextApi/context";
import { SUPERADMIN } from "../utils/constant/stringConstant";
import { setFlyerItemCategories } from "../contextApi/reducer";

export const useFlyerItemCategories = () => {
  const { state, dispatch } = React.useContext(GoFlyerAdminContext);

  const fetchFlyerItemCategories = useCallback(async () => {
    try {
      const result =
        await adminApiService.getManyBaseGfFlyerItemCategoryAdminControllerGfFlyerItemCategory();

      dispatch(setFlyerItemCategories(result.data));
    } catch (error) {
      console.error("Error fetching flyer item categories:", error);
    }
  }, [dispatch]);

  useEffect(() => {
    // Only fetch if data is not already in global context
    if (!state.flyerItemCategories) {
      /**
       * This logic might be redundant and could potentially be removed in the future.
       * However, for now, it is kept to ensure that the condition below does not override this one.
       */
      if (state.user && state.user?.parsedRoles?.name === SUPERADMIN) {
        fetchFlyerItemCategories();
      } else if (state.user && state.user?.merchant?.length === 0) {
        /**
       // If the logged-in user has an empty merchant array, this user is not a department manager but some kind of admin.
       */
        fetchFlyerItemCategories();
      }
      /**
       * If the logged-in user has a gfFlyerItemCategory array, this user is a department manager.
       * For department manager, they can only see certain department.
       */
      if (
        state.user?.gfFlyerItemCategory &&
        state.user?.gfFlyerItemCategory?.length > 0
      ) {
        dispatch(setFlyerItemCategories(state.user.gfFlyerItemCategory));
      }
    }
  }, [
    state.user,
    state.flyerItemCategories,
    fetchFlyerItemCategories,
    dispatch,
  ]);

  /**
   * fetchFlyerItemCategories is needed because in the Tags page.So after I add a new flyer category, I need to refresh the list.
   */
  return {
    flyerItemCategories: state.flyerItemCategories || [],
    fetchFlyerItemCategories,
    setFlyerItemCategories: (categories: GfFlyerItemCategory[]) =>
      dispatch(setFlyerItemCategories(categories)),
  };
};
